import React, { useEffect, useState } from 'react'
import { Button } from '@dasa-health/components-react'
import { ContainerGlobal, Container, Content, Illustration, IconSpinnerWrapper, Title, FixedButtonWrapper } from './styles'
import Group from 'assets/group.svg'
import { SystemOutlineLoading } from '@dasa-health/icons'
import { useHistory } from 'react-router-dom'
import { useUnicoService } from 'services/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'
import { SESSION_STORAGES_KEYS } from 'constants/sessionStorages'
import { useLoginContext } from 'context'
import { goToPage } from 'redesign/utils/goToPage'
import { ROUTES_PATH } from 'constants/routesPath'
import { BiometyDataType, UpdateContactsInicialValues } from 'typings/unico'
import { LoginType } from 'typings/auth'
import { clearStorage } from 'utils'
import { FaceRecognitionErrorScreen } from 'pages/FaceRecognitionErrorScreen'

export const FaceRecognitionSuccessScreen: React.FC = () => {
    const { updateContactsBiometry, authBiometry } = useUnicoService()
    const [loading, setLoading] = useState(false)
    const { operations } = useLoginContext()
    const history = useHistory()
    const [hasServiceError, setHasServiceError] = useState(false)

    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)
    const redirectTo = sessionStorage.getItem(SESSION_STORAGES_KEYS.REDIRECT_TO_URL)

    const TitleLabel =
        biometyDataLS?.origin === UNICO_CONSTANTS.ORIGIN.RECOVER ? 'Pronto! Senha alterada.' : 'Pronto! Cadastrei seu novo contato.'

    async function handleSubmit({ cellphone, email }: UpdateContactsInicialValues) {
        setLoading(true)

        try {
            await updateContactsBiometry(biometyDataLS?.federalTaxId!, biometyDataLS?.id!)

            const data = await authBiometry(biometyDataLS?.federalTaxId!, biometyDataLS?.id!)

            sessionStorage.setItem(
                UNICO_CONSTANTS.STORAGE,
                JSON.stringify({
                    ...biometyDataLS,
                    token: data?.authBiometry.access_token,
                    refreshToken: data?.authBiometry.refresh_token,
                }),
            )

            operations.addPayloadTokenLS({
                token: data?.authBiometry.access_token,
                refreshToken: data?.authBiometry.refresh_token,
                limitedFlow: false,
                redesign: undefined,
            })
            operations.setIdentifier(LoginType.cpf)

            clearStorage([UNICO_CONSTANTS.STORAGE, SESSION_STORAGES_KEYS.REDIRECT_TO_URL, SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY])

            goToPage(redirectTo ? redirectTo : UNICO_CONSTANTS.REDIRECT_HOME)
        } catch (error) {
            console.error(error)
            setHasServiceError(true)
            clearStorage([UNICO_CONSTANTS.STORAGE, SESSION_STORAGES_KEYS.REDIRECT_TO_URL, SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY])
            throw error
        } finally {
            setLoading(false)
        }
    }

    function redirectToLogin() {
        history.push(ROUTES_PATH.SIGN_IN)
    }

    useEffect(() => {
        const checkAndProceed = () => {
            const hasBiometryData = biometyDataLS?.federalTaxId && biometyDataLS?.id && biometyDataLS?.origin

            if (!hasBiometryData) {
                clearStorage([UNICO_CONSTANTS.STORAGE, SESSION_STORAGES_KEYS.REDIRECT_TO_URL, SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY])

                redirectToLogin()
                return
            }

            const storedContacts = sessionStorage.getItem(SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY)

            if (storedContacts) {
                const parsedContacts = JSON.parse(storedContacts)
                handleSubmit(parsedContacts)
            }
        }

        checkAndProceed()
    }, [])

    if (hasServiceError) {
        return <FaceRecognitionErrorScreen />
    }

    return (
        <ContainerGlobal>
            <Container>
                <Content>
                    <Illustration alt="" data-testid="content-illustration" src={Group} />
                    <Title>{TitleLabel}</Title>
                    <FixedButtonWrapper>
                        <Button fullWidth onClick={() => handleSubmit} size="default" type="button" variant="primary">
                            {loading && (
                                <IconSpinnerWrapper style={{ marginRight: 8 }}>
                                    <SystemOutlineLoading />
                                </IconSpinnerWrapper>
                            )}
                            Acessar Nav Dasa
                        </Button>
                    </FixedButtonWrapper>
                </Content>
            </Container>
        </ContainerGlobal>
    )
}
